module.exports = __webpack_public_path__ + "img/people.3134a513.svg";